import { render, staticRenderFns } from "./EntityProducts.vue?vue&type=template&id=1cd4c6d9&scoped=true"
import script from "./EntityProducts.vue?vue&type=script&lang=js"
export * from "./EntityProducts.vue?vue&type=script&lang=js"
import style0 from "./EntityProducts.vue?vue&type=style&index=0&id=1cd4c6d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4c6d9",
  null
  
)

export default component.exports